module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Fuellinsdorf-7806d96cec0dd3da9304d175fe4abc0f.png";